import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import { Location }         from "Utils/API";
import Action               from "dashboard/dist/Core/Action";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import LocationEdit         from "./LocationEdit";
import Main                 from "dashboard/dist/Components/Main";
import Header               from "dashboard/dist/Components/Header";
import ActionList           from "dashboard/dist/Components/ActionList";
import Content              from "dashboard/dist/Components/Content";
import Table                from "dashboard/dist/Components/Table";
import TableHead            from "dashboard/dist/Components/TableHead";
import TableBody            from "dashboard/dist/Components/TableBody";
import TableRow             from "dashboard/dist/Components/TableRow";
import TableHeader          from "dashboard/dist/Components/TableHeader";
import TableCell            from "dashboard/dist/Components/TableCell";
import TablePaging          from "dashboard/dist/Components/TablePaging";
import TableActionList      from "dashboard/dist/Components/TableActionList";
import TableAction          from "dashboard/dist/Components/TableAction";
import DeleteDialog         from "dashboard/dist/Components/DeleteDialog";
import Downloader           from "dashboard/dist/Components/Downloader";

// Actions
import {
    fetchLocations, deleteLocation,
} from "Actions/Admin/Location/LocationActions";



/**
 * The Location List
 */
class LocationList extends React.Component {
    // The Current State
    state = {
        action : Action.get(),
        elemID : 0,
    }

    /**
     * Load the Data
     * @returns {Void}
     */
    componentDidMount() {
        this.fetch();
    }

    /**
     * Fetch the content
     * @param {Object=} params
     * @returns {Void}
     */
    fetch = (params) => {
        this.props.fetchLocations(params || this.props.data.sort);
    }



    /**
     * Starts an Action
     * @param {Object} action
     * @param {Number} elemID
     * @returns {Void}
     */
    startAction = (action, elemID) => {
        this.setState({ action, elemID });
    }

    /**
     * Ends an Action
     * @returns {Void}
     */
    endAction = () => {
        this.startAction(Action.get(), 0);
    }



    /**
     * Handles the Edit Submit
     * @returns {Void}
     */
    editElem = () => {
        this.endAction();
        this.fetch();
    }

    /**
     * Handles the Delete Submit
     * @returns {Promise}
     */
    deleteElem = async () => {
        const elemID = this.state.elemID;
        this.endAction();
        await this.props.deleteLocation(elemID);
        this.fetch();
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { action, elemID                      } = this.state;
        const { data, route                         } = this.props;
        const { canEdit, list, total, sort, loading } = data;

        const elemName = Utils.getValue(list, "locationID", elemID, "name");

        return <Main>
            <Header message="LOCATIONS_NAME" icon="location" route={route}>
                <ActionList data={data} onAction={this.startAction} />
            </Header>
            <Content isLoading={loading}>
                <Table fetch={this.fetch} sort={sort} none="LOCATIONS_NONE_AVAILABLE">
                    <TableHead>
                        <TableHeader field="name"         message="GENERAL_NAME"        grow="2" bigMobile />
                        <TableHeader field="address"      message="GENERAL_ADRRESS"     />
                        <TableHeader field="localityName" message="LOCALITIES_SINGULAR" />
                        <TableHeader field="provinceName" message="PROVINCES_SINGULAR"  />
                        <TableHeader field="countryName"  message="COUNTRIES_SINGULAR"  />
                    </TableHead>
                    <TableBody>
                        {list.map((elem) => <TableRow key={elem.locationID} elemID={elem.locationID}>
                            <TableCell message={elem.name}         circle={elem.statusColor} />
                            <TableCell message={elem.address}      />
                            <TableCell message={elem.localityName} />
                            <TableCell message={elem.provinceName} />
                            <TableCell message={elem.countryName}  />
                        </TableRow>)}
                    </TableBody>
                    <TablePaging total={total} />
                    <TableActionList onAction={this.startAction} canEdit={canEdit}>
                        <TableAction action="VIEW"   message="LOCATIONS_VIEW_TITLE"   route={route} />
                        <TableAction action="EDIT"   message="LOCATIONS_EDIT_TITLE"   />
                        <TableAction action="DELETE" message="LOCATIONS_DELETE_TITLE" />
                    </TableActionList>
                </Table>
            </Content>

            <LocationEdit
                open={action.isVCE}
                elemID={elemID}
                onSubmit={this.editElem}
                onClose={this.endAction}
            />
            <DeleteDialog
                open={action.isDelete}
                title="LOCATIONS_DELETE_TITLE"
                message="LOCATIONS_DELETE_TEXT"
                content={elemName}
                onSubmit={this.deleteElem}
                onClose={this.endAction}
            />
            <Downloader
                download={action.isExport}
                source={Location.export()}
                onLoad={this.endAction}
            />
        </Main>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchLocations : PropTypes.func.isRequired,
        deleteLocation : PropTypes.func.isRequired,
        data           : PropTypes.object.isRequired,
        route          : PropTypes.string.isRequired,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            data : state.location,
        };
    }
}

export default connect(LocationList.mapStateToProps, {
    fetchLocations, deleteLocation,
})(LocationList);
